__turbopack_context__.v({
  "actionsRow": "SocialIndividualModal-module__XsY5_q__actionsRow",
  "backdrop": "SocialIndividualModal-module__XsY5_q__backdrop",
  "closeBtn": "SocialIndividualModal-module__XsY5_q__closeBtn",
  "copyBtn": "SocialIndividualModal-module__XsY5_q__copyBtn",
  "descriptionBox": "SocialIndividualModal-module__XsY5_q__descriptionBox",
  "descriptionText": "SocialIndividualModal-module__XsY5_q__descriptionText",
  "headerInfo": "SocialIndividualModal-module__XsY5_q__headerInfo",
  "headerRow": "SocialIndividualModal-module__XsY5_q__headerRow",
  "iconCircle": "SocialIndividualModal-module__XsY5_q__iconCircle",
  "linkBox": "SocialIndividualModal-module__XsY5_q__linkBox",
  "linkUrl": "SocialIndividualModal-module__XsY5_q__linkUrl",
  "modalCard": "SocialIndividualModal-module__XsY5_q__modalCard",
  "modalFadeIn": "SocialIndividualModal-module__XsY5_q__modalFadeIn",
  "modalPopIn": "SocialIndividualModal-module__XsY5_q__modalPopIn",
  "primaryCtaBtn": "SocialIndividualModal-module__XsY5_q__primaryCtaBtn",
  "secondaryBtn": "SocialIndividualModal-module__XsY5_q__secondaryBtn",
  "subtitle": "SocialIndividualModal-module__XsY5_q__subtitle",
  "title": "SocialIndividualModal-module__XsY5_q__title",
  "titleRow": "SocialIndividualModal-module__XsY5_q__titleRow",
  "toastFade": "SocialIndividualModal-module__XsY5_q__toastFade",
  "toastPill": "SocialIndividualModal-module__XsY5_q__toastPill",
  "verifiedBadge": "SocialIndividualModal-module__XsY5_q__verifiedBadge",
});
